// The speaker button in the arena: mutes or unmutes battle sounds. Vibration stays on either way.
import { useState, type CSSProperties } from "react";
import { isMuted, setMuted } from "./sound.js";

export function SoundToggle({ style }: { style?: CSSProperties }) {
  const [muted, setM] = useState(isMuted());
  const flip = () => {
    setMuted(!muted);
    setM(!muted);
  };
  return (
    <button onClick={flip} aria-label={muted ? "Turn sound on" : "Mute sound"} aria-pressed={muted} style={{ width: "36px", height: "36px", borderRadius: "50%", border: "1px solid rgba(255,255,255,0.1)", background: "rgba(22,27,34,0.75)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 8, ...style }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={muted ? "#8B949E" : "#FFFFFF"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M11 5 L6 9 H3 v6 h3 l5 4 z" fill={muted ? "none" : "#FFFFFF"}></path>
        {muted ? <path d="M16 9 l5 6 M21 9 l-5 6"></path> : <path d="M15.5 8.5 a5 5 0 0 1 0 7 M18.5 5.5 a9 9 0 0 1 0 13"></path>}
      </svg>
    </button>
  );
}
